// extracted by mini-css-extract-plugin
export default {"rating":"nI-z","numberOfStars":"oI-z","count":"pI-z","barGraphSpacing":"qI-z","barGraph":"rI-z"};